<template>
  <div class="editorTable"></div>
</template>

<script>
export default {
  name: 'EditorTable',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.editorTable {
}
</style>
